import { EOfferType, EDealType } from 'shared/types/wantType';

export const prepareCategoryCa = (dealType: EDealType, offerType: EOfferType): string => {
  if (dealType === EDealType.Sale && offerType === EOfferType.Apartment) {
    return 'flatSale';
  }
  if (dealType === EDealType.Sale && offerType === EOfferType.Suburban) {
    return 'houseSale';
  }
  if (dealType === EDealType.Rent && offerType === EOfferType.Apartment) {
    return 'flatRent';
  }
  if (dealType === EDealType.Rent && offerType === EOfferType.Suburban) {
    return 'houseRent';
  }

  return '';
};
